import { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { CompetitionSelect } from "./CompetitionSelect";
import { Team } from "./TeamRow";

export const UpcomingMatches = () => {
  const [comp, setComp] = useState("SA");
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/matches/upcoming", { params: { competition: comp } }).then((r) => setData(r.data)).catch(() => setData({ matches: [] }));
  }, [comp]);

  return (
    <div className="card-surface p-4 sm:p-6 space-y-4 sm:space-y-5" data-testid="upcoming-matches">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight whitespace-nowrap">Prossime partite</h2>
        <div className="w-36 sm:w-44"><CompetitionSelect value={comp} onChange={setComp} testId="upcoming-competition-select" /></div>
      </div>
      {!data && <div className="h-40 animate-pulse rounded-lg bg-[#121824]" />}
      {data?.matches?.length === 0 && <p className="text-slate-400 text-sm">Nessuna partita disponibile per il pronostico.</p>}
      <ul className="divide-y divide-[#26334D]">
        {data?.matches?.slice(0, 8).map((m) => (
          <li key={m.match_id} className="py-3" data-testid={`upcoming-match-${m.match_id}`}>
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-2">{m.round_label} · {fmtDate(m.utc_date)}</p>
            <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3 text-sm">
              <Team team={m.home} />
              <span className="font-display text-slate-500">VS</span>
              <Team team={m.away} align="right" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
